import { render, staticRenderFns } from "./PreFooters.vue?vue&type=template&id=6f0aaa8c"
import script from "./PreFooters.vue?vue&type=script&lang=js"
export * from "./PreFooters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports